




















import Vue from 'vue';

export default Vue.extend({
  name: 'Note',

  props: {
    title: {
      type: String,
      default: 'Title',
    },

    description: {
      type: String,
      default: 'Description of note.',
    },

    icon: {
      type: String,
      default: 'mdi-rotate-orbit',
    },

    color: {
      type: String,
      default: 'rgb(255, 196, 1)',
    },
  },
});
